import * as React from "react"
import { GroupByDateType, GroupByDate } from "../../../components/GroupByDate"
import { BPMChart } from "../../../components/Chart"
import { resultDateTransformer } from "../../../utils/date"
import { BPMAnalyticsAPI } from "../../../api"
import { SeriesTemplate, CommonSeriesSettings, ArgumentAxis, Label, TickInterval, Legend, Series, Point, ValueAxis } from "devextreme-react/chart"
import { GroupByType } from "../../../components/GroupByType"
import { PlatformContext } from "components/context/platform"

export const CumulativeSubscriptionChart: React.FunctionComponent<{}> = () => {

    const [groupDateBy, setGroupDateBy] = React.useState<GroupByDateType>('day')
    const [groupBy, setGroupBy] = React.useState<string | undefined>('membership')
    const platform = React.useContext(PlatformContext)
    const isCreate = platform == 'create'

    const toolbarItems = GroupByType([{ val: 'membership', display: 'Membership' }, isCreate ? undefined! : { val: 'library', display: 'Library' }].filter(Boolean), groupBy, (selected) => {
        setGroupBy(selected)
    }).concat(GroupByDate(groupDateBy, (selected) => {
        setGroupDateBy(selected)
    }))

    return (
        <BPMChart title='Cumulative Subscriptions' type='spline'
            additionalParams={{ groupBy: groupBy, groupDateBy }}
            onRequestLoad={(options, signal) => {
                return resultDateTransformer(BPMAnalyticsAPI.get<any>('membership', options, signal))
            }} toolBarItems={() => toolbarItems}>
            {groupBy && <SeriesTemplate
                nameField={groupBy}
            />}
            {!groupBy && <Series name='Subscriptions' />}
            <CommonSeriesSettings type='spline'
                valueField="count"
                argumentField="date">
                <Point size={0} hoverStyle={{ size: 14, border: { width: 5 }, color: '#000' }}
                    hoverMode='onlyPoint' />
            </CommonSeriesSettings>
            <ArgumentAxis>
                <Label format={groupDateBy == 'month' ? 'month' : "shortDate"} />
                <TickInterval days={groupDateBy == 'day' ? 1 : undefined} weeks={groupDateBy == 'week' ? 1 : undefined} months={groupDateBy == 'month' ? 1 : undefined} />
            </ArgumentAxis>
            {groupBy == 'library' && <ValueAxis type='discrete' />}
            <Legend visible />
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Dashboard/charts/CumulativeSubscriptionChart.tsx